<template>
    <div class="columns is-centered is-multiline">
        <div class="column is-full has-text-centered">
            Parece que no hay una cantidad inicial de stock
        </div>
        <div class="column is-full has-text-centered">
            <b-button
                type="is-primary"
                rounded
                @click="mainSkuModal=true"
                >
                Iniciar control de stock
            </b-button>
        </div>

        <b-modal :active.sync="mainSkuModal" scroll="keep">
            <div class="modal-card" style="width:auto">

                <div class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-two-thirds">
                            <b-field label="Cantidad">
                                <b-numberinput
                                v-model="newMainSku.quantity"
                                rounded
                                type="is-light"
                                min="0">
                                </b-numberinput>
                            </b-field>
                        </div>
                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            @click="createSku">
                                <b-icon icon="save" size="is-small"></b-icon>
                                Guardar datos
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { postHandler } from '../../../../services/http'
export default {
    props:{
        skuCreate:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            newMainSku:{
                variant:null
            },
            mainSkuModal:false,
        }
    },
    methods:{
        async createSku(){
            var msg = {
                resource:"notify"
            }
            let resp = await postHandler(this.skuCreate, this.newMainSku, {error:msg, success:msg})
            this.$emit("done")
        }
    }
}
</script>